export const APP_TITLE = 'Partner Hub'
export const DEFAULT_LANGUAGE = 'en'
export const SIGNIN_URL = 'ac/partnerhub-portal/signin'
export const HELP_URL = 'sac/partnerhub-portal/request-help/send'
export const REGISTER_URL = 'sac/partnerhub-portal/self-register-pay-later/send'
export const CAPTCHA_URL = 'sac/partnerhub-portal/new-captcha'
